import axios from "axios";
import LocalStorageService from "./localStorageService";
import { authService } from '../configs/constants';
// import Cookies from 'js-cookie';

//To globally set cookies in request headers. need to do for fetch separately
axios.defaults.withCredentials = true;
// LocalstorageService
const localStorageService = LocalStorageService.getService();
// Add a request interceptor
axios.interceptors.request.use(
    config => {
        const token = localStorageService.getAccessToken();
        const code = window.localStorage.getItem("Selected-Company-Code");

        // Retrieve the idToken cookie using js-cookie
        // const idToken = Cookies.get('idToken');


        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }
        if (code) config.headers['company-code'] = code;

        // Manually set the idToken cookie in the header
        // console.log("IDTOKEN------------------<<<<<<<<<<<<<<<<<<<", idToken, Cookies);
        // if (idToken) {
        //     config.headers['Cookie'] = `idToken=${idToken}`;
        // }

        // config.headers['Content-Type'] = 'application/json';
        // config.headers["appname"] = "institutionalLandlordPortal";
        return config;
    },
    error => {
        Promise.reject(error)
    });


axios.interceptors.response.use((response) => {
    return response;
}, function (error) {
    const originalRequest = error.config;
    // console.log({ originalRequest })
    // if (error.response.status === 401) {
    //     // history.push('/login');
    //     return Promise.reject(error);
    // }
    // console.log("response====>",error);
    // Handle 303 See Other
    if (error.response.status === 303) {
        const redirectUrl = error.response.data.redirectTo;
        if (redirectUrl) {
            handleSSORedirect(redirectUrl);
        }
        return Promise.reject(new Error('Redirecting to SSO login'));
    }

    if (error.response.status === 401 && !originalRequest._retry) {

        originalRequest._retry = true;
        const userInformation = JSON.parse(localStorage.getItem('login-response'))
        return axios.post(`${authService}/user/auth/refresh`,
            {
                "refreshToken": userInformation.refreshToken,
                "username": userInformation.data.username
            })
            .then(res => {
                if (res.status === 200) {
                    const updatedInfo = res?.data.result
                    const updateUserInfo = {
                        ...userInformation,
                        exp: updatedInfo.exp,
                        iat: updatedInfo.iat,
                        refreshToken: updatedInfo.refreshToken,
                        token: updatedInfo.accessToken
                    }
                    const data = JSON.stringify(updateUserInfo)
                    localStorage.setItem('login-response', data);
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(localStorage.getItem('login-response')).accessToken;
                    return axios(originalRequest);
                }
            })
    }
    return Promise.reject(error);
});


const handleSSORedirect = (url) => {
    // alert("redirect to sso--->");
    window.location.href = url
};

export default axios;